<template>
  <div v-if="close_container" :class="[type !== 'default' ? 'notification '+type : '']" class="modal-container">
    <transition name="fade">
      <div v-if="open_modal" class="modal-overlay"></div>
    </transition>
    <transition name="slide-fade">
      <div v-if="open_modal" :class="[{keepratio : keepratio},  size]" class="modal">
        <div class="modal-header">
          <span class="modal-title">
            <h2>{{ title }}</h2>
            <span class="close" @click="vCloseModal"><i class="material-icons">close</i></span>
          </span>
          <slot name="modal_header"></slot>
        </div>
        <div class="modal-content">
          <slot name="modal_content"></slot>
        </div>
        <div class="modal-footer">
          <slot name="modal_footer"></slot>
        </div>
      </div>
    </transition>	
  </div>
</template>

<script>
import './lib/google-material/css/google-material.css';
export default {
  name: 'CustomModal',
  data() {
    return {
      open_modal: false,
      close_container: false,
    }
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    open: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'default'
    },
    size: {
      type: String,
      default: 'lg'
    },
    keepratio: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    vCloseModal() {
      this.open_modal = false;

      setTimeout(() => {
        this.close_container = false;
        this.$emit('close-modal');
      }, 200);

      document.body.classList.remove("no-scroll");
    }
  },
  computed: {
    getOpen() { return this.$props.open; }
  }, 
  watch: {
    getOpen: {
      immediate: true,
      handler(val){
        if(val) {
          this.close_container = true;
          document.body.classList.add("no-scroll");
          setTimeout(() => { this.open_modal = true;}, 50);
        } else {
          this.open_modal = false;
          document.body.classList.remove("no-scroll");
          setTimeout(() => { this.close_container = false;}, 300);
        }
      }
    }
  }
}
</script>

<style scoped>
.modal-container {
  height: 100vh;
  position: fixed;
  z-index: 20000;
  width: 100vw;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-overlay {
  background-color: rgba(0,0,0,0.8);
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 30000;
}
.modal {
  background-color: #fff;
  padding: 30px;
  position: absolute;
  z-index: 40000;
  border-radius: 5px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  min-height: 70vh;
}
.modal.lg {
  width: 90vw;
}
.modal.md {
  width: 70vw;
}
.modal.sm {
  width: 50vw;
}
.modal.xs {
  width: 30vw;
}
.modal .modal-header {
  margin-bottom: 15px;
}
.modal .modal-header .modal-title {
  display: flex;
  justify-content: space-between;
}
.modal .modal-header .modal-title h2 {
  font-size: 1rem;
  flex: 1;
  white-space: nowrap;
  margin-right: 10px;
  color: rgba(0,0,0,0.8);
}
.modal .modal-header .modal-title .close {
  cursor: pointer;
}
.modal .modal-content {
  overflow: scroll;
  flex: 1;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.slide-fade-enter-active {
  transition: all .4s ease;
}
.slide-fade-leave-active {
  transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to {
  transform: translateY(200px);
  opacity: 0;
}
.notification .modal {
  max-width: 400px;
  min-height: 350px;
}
.modal.keepratio {
  min-height: 250px;
}
.notification.success .modal {
  background-color: #66bb6a;
}
.notification.success .modal .modal-content:before {
  content: '\e5ca';
  font-family: 'Material Icons';
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 8rem;
  border: solid 5px #338a3e;
  color: #338a3e;
  border-radius: 50%;
  width: 150px;
  height: 150px;
  margin: auto;
}
.notification.error .modal {
  background-color: #ef5350;
}
.notification.error .modal .modal-content:before {
  content: '\e5cd';
  font-family: 'Material Icons';
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 8rem;
  border: solid 5px #b61827;
  color: #b61827;
  border-radius: 50%;
  width: 150px;
  height: 150px;
  margin: auto;
}
.notification.error .modal .close i {
  color: #b61827;
}
/deep/
.notification.error .modal-content p {
  color: #b61827;
  font-family: 'Lato-Bold';
  font-size: 1.6rem;
  margin: 10px 0px;
}
/deep/
.notification.success .modal-content p {
  color: #338a3e;
  font-family: 'Lato-Bold';
  font-size: 1.6rem;
  margin: 10px 0px;
}

@media screen and (max-width: 800px){
  .modal-container div.modal {
    width: 92vw;
  }
}

</style>